import React, { useGlobal, useState } from 'reactn';
import { DeliveryHistoryTimelineStyled } from './DeliveryHistoryTimelineStyled';
import CurrentStatusPill from '../../_common/currentStatusPill';
import Icon from '../../_common/icons/ReturnIcons';
import DeliveryTimelineItem from '../../_common/deliveryTimelineItem';

const DeliveryHistoryTimeline = ({ trackingItem, permaExpand }) => {
    const [selectedTrackingItemDetails] = useGlobal("selectedTrackingItemDetails");
    const [isExpanded, setIsExpanded] = useState(false);


    return (
        <DeliveryHistoryTimelineStyled>
            <div className='statusInfo'>
                <CurrentStatusPill hasBackground={true} selected={false} trackingItem={trackingItem} />
                {(!permaExpand && selectedTrackingItemDetails  ) && selectedTrackingItemDetails.length > 1 && <div className='plusIconWrapper gtm-accordion' onClick={() => setIsExpanded(!isExpanded)}>
                    <Icon src={isExpanded ? "minusIcon" : "plusIcon"} />
                </div>}
            </div>
            {selectedTrackingItemDetails && <div>
                {selectedTrackingItemDetails.filter((el, index) => isExpanded || permaExpand ? el : index === 0).map((item, index) => {
                    return <DeliveryTimelineItem key={index} 
                    isLastItem={(isExpanded || permaExpand) && index === selectedTrackingItemDetails.filter((el, index) => isExpanded || permaExpand ? el : index === 0).length - 1} 
                    status={item.activity} date={item.date} location={item.location} isCurrentStatus={index === 0} />
                })}

            </div>}


        </DeliveryHistoryTimelineStyled>
    );
};

export default DeliveryHistoryTimeline;